import { api } from '@data/store';
import {
  ListResponse,
  ReportEntity,
  SprintEntity,
  SprintProductEntity,
  SprintProductReportsParams,
} from '@data/utils/types';

export const fetchSprints = (params?: {
  from?: string | Date;
  to?: string | Date;
  offset?: number;
  limit?: number;
}): Promise<{ items: SprintEntity[]; count: number }> =>
  api.get(`/sprints`, {
    params,
  });

export const fetchSprintProductReports = async ({
  productId,
  sprint,
  chapters,
  asClient,
  incidentWork,
}: SprintProductReportsParams): Promise<ListResponse<ReportEntity>> =>
  api.get(`sprints/${sprint?.id}/products/${productId}/reports`, { params: { chapters, asClient, incidentWork } });

export const fetchSprint = (sprintId: string): Promise<SprintEntity> => api.get(`/sprints/${sprintId}`);

export const fetchSprintProducts = ({
  sprintId,
  productId,
  asClient,
}: {
  sprintId: string | undefined;
  productId: string | undefined;
  asClient?: boolean;
}): Promise<ListResponse<SprintProductEntity>> =>
  api.get(`/sprints/${sprintId}/products/${productId}`, { params: { asClient } });
